import axios from "axios";

// axios.defaults.baseURL = "http://localhost:8000/api/";
// axios.defaults.baseURL = "http://wfdapi.hyathi.com/api/";
// axios.defaults.baseURL = "https://uddeshyaagrawal.com/api";
axios.defaults.baseURL = "https://my-adm.womenfirstdigital.org/api/";

export default axios;
